/** 公開トークンの接頭辞(ADR-0015)。 */
export const PUBLIC_TOKEN_PREFIX = 'pv_';
/**
 * 共有フォルダのトークンの接頭辞([ADR-0045](../../../../docs/adr/0045-share-folder-links.md))。
 *
 * **盤面のトークン(`pv_`)と分ける。** 表をまたいでも衝突しないことを構造で保証し
 * (DB の CHECK 制約でも固定する)、ビューアが URL を見ただけで開き方を決められる。
 * 強度は同じ(128 bit の暗号論的乱数)。
 */
export const SHARE_FOLDER_TOKEN_PREFIX = 'pf_';
/**
 * 共有フォルダのトークンの、接頭辞より後ろ。
 *
 * 128 bit を base64url で表すと 22 文字。ビューアの盤面のトークンの検査(`isValidToken`)と
 * 同じく**将来伸びる余地を持たせて範囲で見る**。上限は**列(`varchar(64)`)に収まる長さ**。
 */
const SHARE_FOLDER_TOKEN_BODY = /^[A-Za-z0-9_-]{16,61}$/u;
/**
 * 共有フォルダのトークンの形か([ADR-0046](../../../../docs/adr/0046-public-share-folder-api.md) の決定 1)。
 *
 * **公開 API は DB を引く前にこれで弾く**(404)。入力はトークンだけなので、
 * `/` や `..` のような**パスとして意味を持つ文字はここで止まる**。
 * ビューア(#267)も問い合わせる前に使う。
 */
export function isShareFolderToken(token) {
    if (typeof token !== 'string')
        return false;
    if (!token.startsWith(SHARE_FOLDER_TOKEN_PREFIX))
        return false;
    return SHARE_FOLDER_TOKEN_BODY.test(token.slice(SHARE_FOLDER_TOKEN_PREFIX.length));
}
//# sourceMappingURL=public-api.js.map